<template>
  <v-app>
    <!-- 🔹 Search Form -->
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel1">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                Search
              </v-expansion-panel-title>

              <v-form @submit.prevent="submitForSearch">
                <v-row class="pa-2">
                  <v-col lg="4" md="4" cols="12">
                    <v-date-input
                      input-format="dd/mm/yyyy"
                      v-model="from_date.value.value"
                      label="From Date"
                      prepend-icon=""
                      prepend-inner-icon="mdi-calendar-month"
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      clearable
                      :error-messages="from_date.errorMessage.value"
                    />
                  </v-col>

                  <v-col lg="4" md="4" cols="12">
                    <v-date-input
                      input-format="dd/mm/yyyy"
                      v-model="to_date.value.value"
                      label="To Date"
                      prepend-icon=""
                      prepend-inner-icon="mdi-calendar-month"
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      clearable
                      :error-messages="to_date.errorMessage.value"
                    />
                  </v-col>

                  <v-col lg="2" md="2" cols="12">
                    <v-btn class="bg-brand w-15" type="submit" ref="searchButton">
                      Search
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <!-- 🔹 Records Table -->
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                Payment Records
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col lg="4" md="4" cols="12" class="pt-5">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      clearable
                    />
                  </v-col>

                  <v-col lg="6" md="6" cols="12" class="pt-5">
                    <div class="d-flex align-center flex-column">

                      <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                        <v-btn prepend-icon="mdi-download" variant="flat" color="success" @click="exportToCSV">
                          CSV
                        </v-btn>

                        <v-btn prepend-icon="mdi-download" variant="flat" color="primary" @click="exportToExcel">
                          EXCEL
                        </v-btn>

                        <v-btn prepend-icon="mdi-download" variant="flat" color="red" @click="exportToPDF">
                          PDF
                        </v-btn>
                      </v-btn-group>

                    </div>
                  </v-col>
                </v-row>

                <!-- 🔹 Data Table -->
                <v-data-table
                  :headers="headers"
                  :items="getSchema"
                  :loading="loading"
                  :search="search"
                  :hover="true"
                  density="compact"
                  :items-per-page="-1"
                  hide-default-footer
                >
                  <template v-slot:item.index="{ index }">{{ index + 1 }}</template>
                  <template v-slot:item.payment_method="{ item }">{{ item.payment_method }}</template>
                  <template v-slot:item.payment_account="{ item }">{{ item.payment_account?.name }}</template>
                  <template v-slot:item.payment_account_code="{ item }">{{ item.payment_account?.code }}</template>
                  <template v-slot:item.total_amount="{ item }">{{ item.total_amount }}</template>
                  <template v-slot:item.challan_no="{ item }">{{ item.challan_no }}</template>
                  <template v-slot:item.challan_date="{ item }">{{ item.challan_date }}</template>

                  <template v-slot:item.approval_status_display="{ item }">
                    <v-chip
                      v-if="item.approval_current_process && item.approval_current_process.status === 'Pending'"
                      color="yellow-darken-3"
                      size="small"
                    >
                      Wating for {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>

                    <v-chip
                      v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                      color="green"
                      size="small"
                    >
                      Approved By {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>
                    <v-chip
                      v-else-if="item.approval_current_process && item.approval_current_process.status === 'Cancelled'"
                      color="red"
                      size="small"
                    >
                      Cancelled By  {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>
                    <v-chip
                      v-else
                      color="green"
                      size="small"
                    >
                      {{ item.approval_status }}
                    </v-chip>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <v-btn size="x-small" color="primary" class="mr-2"
                           @click="openChallanInfoModal(item)">
                      Challan Info
                    </v-btn>

                    <v-btn size="x-small" color="success" @click="paymentDetails(item)">Details</v-btn>
                  </template>

                  <template v-slot:body.append>
                    <tr style="background:#f5f5f5">
                      <td colspan="5" class="text-right font-weight-bold">Total Amount:</td>
                      <td class="text-end font-weight-bold">{{ totalAmount }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>

            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <!-- 🔹 Challan Info Modal -->
    <v-dialog v-model="challanInfoModal" max-width="900">
      <v-card class="pa-5">

        <v-card-title>
          <span class="text-h6">VAT Challan Info</span>
        </v-card-title>

        <v-form @submit.prevent="submitChallan">
          <v-card-text>
            <v-row>

              <v-col cols="12" md="6">
                <v-text-field
                  label="Challan No *"
                  v-model="challan_no.value.value"
                  variant="outlined"
                  density="compact"
                  clearable
                  :error-messages="challan_no.errorMessage.value"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-date-input
                  input-format="dd/mm/yyyy"
                  label="Challan Date *"
                  v-model="challan_date.value.value"
                  prepend-icon=""
                  prepend-inner-icon="mdi-calendar"
                  variant="outlined"
                  density="compact"
                  bg-color="grey-lighten-4"
                  clearable
                  :error-messages="challan_date.errorMessage.value"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  label="Challan Link"
                  v-model="challan_link.value.value"
                  variant="outlined"
                  density="compact"
                  clearable
                  :error-messages="challan_link.errorMessage.value"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-file-input
                  label="Challan Copy"
                  v-model="challan_attachment_copy.value.value"
                  prepend-icon=""
                  prepend-inner-icon="mdi-paperclip"
                  variant="outlined"
                  density="compact"
                  accept=".jpg,.png,.pdf"
                  :error-messages="challan_attachment_copy.errorMessage.value"
                />
              </v-col>

            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn variant="text" @click="challanInfoModal = false">Cancel</v-btn>

            <v-btn color="success" variant="flat" type="submit" :loading="loading">Submit</v-btn>
          </v-card-actions>
        </v-form>

      </v-card>
    </v-dialog>

  </v-app>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import { useRouter } from "vue-router";

export default {
  name: "TaxPaymentList",

  data: () => ({
    panel1: [0],
    panel2: [0],
    search: "",
    challanInfoModal: false,
    selectedPaymentId: null,

    headers: [
      { title: "#SL", key: "index", align: "center" },
      { title: "Code", key: "code", align: "left" },
      { title: "Payment Method", key: "payment_method", align: "center" },
      { title: "Payment Account", key: "payment_account", align: "center" },
      { title: "Account Code", key: "payment_account_code", align: "center" },
      { title: "Amount", key: "total_amount", align: "end" },
      { title: "Challan No", key: "challan_no", align: "left" },
      { title: "Challan Date", key: "challan_date", align: "left" },
      { title: "Approval Status", key: "approval_status_display", align: "left" },
      { title: "Action", key: "action", align: "center" },
    ]
  }),

  setup() {
    const store = useStore();
    const loading = ref(false);
    const router = useRouter();

    /** 🔹 Search Form Fields */
    const from_date = useField("from_date");
    const to_date = useField("to_date");

    /** 🔹 Challan Modal Fields (Validation Required) */
    const { handleSubmit: handleChallanSubmit } = useForm({
      validationSchema: yup.object({
        challan_no: yup.string().required().label("Challan No"),
        challan_date: yup.date().required().label("Challan Date"),
        challan_link: yup.string().nullable().label("Challan Link"),
        challan_attachment_copy: yup.mixed().nullable().label("Attachment File"),
      }),
    });

    const challan_no = useField("challan_no");
    const challan_date = useField("challan_date");
    const challan_link = useField("challan_link");
    const challan_attachment_copy = useField("challan_attachment_copy");

    /** 🔹 Search Submit */
    const submitForSearch = async () => {
      loading.value = true;
      try {
        await store.dispatch("getVatPaymentList", {
          from_date: formattedDate(from_date.value.value),
          to_date: formattedDate(to_date.value.value),
        });
      } catch (error) {
        toast.error(error?.response?.data?.message || "Error fetching list");
      }
      loading.value = false;
    };

    return {
      loading,
      from_date,
      to_date,
      challan_no,
      challan_date,
      challan_link,
      challan_attachment_copy,
      handleChallanSubmit,
      submitForSearch,
      store,
      router,
    };
  },

  computed: {
    getSchema() {
      return this.$store.getters.getVatPaymentList || [];
    },
    totalAmount() {
      return this.getSchema.reduce((sum, item) => sum + Number(item.total_amount || 0), 0);
    },
  },

  methods: {
    /** 🔹 OPEN CHALLAN MODAL */
    openChallanInfoModal(item) {
      this.selectedPaymentId = item.id;
      this.challanInfoModal = true;

      this.challan_no.value.value = item.challan_no;
      this.challan_date.value.value = item.challan_date;
      this.challan_link.value.value = item.challan_link;
      // this.challan_attachment_copy.value.value = item.challan_attachment_copy;
    },

    paymentDetails(item){
      // this.$store.dispatch("getVatPaymentDetails", {id:item.id});
      this.router.push({ 
        name: "vat-payemnt-details", 
        query: { id: item.id },
      });
    },
    submitChallan: null,
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.searchButton?.$el?.click();
    });
  },

  created() {
    /** Build Submit Function Here (Access this.store inside created) */
    this.submitChallan = this.handleChallanSubmit(async (values) => {
      this.loading = true;

      try {
        const formData = new FormData();
        formData.append("acc_vat_payment_master_id", this.selectedPaymentId);
        formData.append("challan_no", values.challan_no);
        formData.append("challan_date", formattedDate(values.challan_date));
        formData.append("challan_link", values.challan_link);
        formData.append("challan_attachment_copy", values.challan_attachment_copy);

        await this.store.dispatch("storeVatChallanInfo", formData);

        toast.success("Challan information saved successfully");
        this.challanInfoModal = false;

      } catch (error) {
        toast.error(error?.response?.data?.message || "Error saving challan info");
      }

      this.loading = false;
    });
  }
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>
